<template>
	<div class="form-group" :class="className">
		<label class="form-label" v-show="label">{{ label }}</label>
		<template v-if="viewMode === 'both'">
			<div class="row gx-2">
				<div class="col">
					<select
						class="form-select"
						:class="[{ active: range.from.model !== '' }, inputClassName]"
						v-model="range.from.model"
						@change="updateFilterFrom()"
					>
						<option value="">{{ range.from.title }}</option>
						<option
							v-for="option in range.options"
							:value="option"
							:key="option"
							:selected="option == range.from.model"
						>
							<RangeFilterOption :option="option" :rangeMode="rangeMode" />
						</option>
					</select>
				</div>
				<div class="col">
					<select
						class="form-select"
						:class="[{ active: range.till.model !== '' }, inputClassName]"
						v-model="range.till.model"
						@change="updateFilterTill()"
					>
						<option value="">{{ range.till.title }}</option>
						<option
							v-for="option in range.options"
							:value="option"
							:key="option"
							:selected="option == range.till.model"
						>
							<RangeFilterOption :option="option" :rangeMode="rangeMode" />
						</option>
					</select>
				</div>
			</div>
		</template>
		<template v-if="viewMode === 'from'">
			<select
				class="form-select"
				:class="[{ active: range.from.model !== '' }, inputClassName]"
				v-model="range.from.model"
				@change="updateFilterFrom()"
			>
				<option value="">{{ range.from.title }}</option>
				<option
					v-for="option in range.options"
					:value="option"
					:key="option"
					:selected="option == range.from.model"
				>
					<RangeFilterOption :option="option" :rangeMode="rangeMode" />
				</option>
			</select>
		</template>
		<template v-if="viewMode === 'till'">
			<select
				class="form-select"
				:class="[{ active: range.till.model !== '' }, inputClassName]"
				v-model="range.till.model"
				@change="updateFilterTill()"
			>
				<option value="">{{ range.till.title }}</option>
				<option
					v-for="option in range.options"
					:value="option"
					:key="option"
					:selected="option == range.till.model"
				>
					<RangeFilterOption :option="option" :rangeMode="rangeMode" />
				</option>
			</select>
		</template>
	</div>
</template>

<script>
import store from '@/store'
import RangeFilterOption from '@/components/ui/form/RangeFilterOption'

export default {
	name: 'FormSelectRange',
	components: {
		RangeFilterOption,
	},
	data() {
		return {
			selected: '',
			type: 'string',
			range: {
				from: {
					title: 'ab',
					key: '',
					model: '',
				},
				till: {
					title: 'bis',
					key: '',
					model: '',
				},
				options: [],
			},
		}
	},
	props: {
		label: {
			type: String,
			default: '',
		},
		rangeMode: {
			type: String,
			default: 'price-consumerPriceGross',
		},
		viewMode: {
			type: String,
			default: 'both',
		},
		className: {
			type: String,
			default: '',
		},
		inputClassName: {
			type: String,
			default: '',
		},
		placeholder: {
			type: String,
			default: '- Alle -',
		},
	},
	methods: {
		setupRangeMode() {
			if (this.rangeMode === 'price-consumerPriceGross') {
				this.type = 'string'
				this.range.from = {
					title: 'ab',
					key: 'range-from-price-consumerPriceGross',
					model: '',
				}
				this.range.till = {
					title: 'bis',
					key: 'range-till-price-consumerPriceGross',
					model: '',
				}
				this.range.options = [
					0, 500, 1000, 1500, 2000, 2500, 3000, 3500, 4000, 4500, 5000, 6000,
					7000, 8000, 9000, 10000, 11000, 12000, 13000, 14000, 15000, 16000,
					17000, 18000, 19000, 20000, 21000, 22000, 23000, 24000, 25000, 26000,
					27000, 28000, 29000, 30000, 32500, 35000, 37500, 40000, 42500, 45000,
					47500, 50000, 52500, 55000, 57500, 60000, 62500, 65000, 67500, 70000,
				]
			} else if (this.rangeMode === 'milage') {
				this.type = 'number'
				this.range.from = {
					title: 'ab',
					key: 'range-from-mileage',
					model: '',
				}
				this.range.till = {
					title: 'bis',
					key: 'range-till-mileage',
					model: '',
				}
				this.range.options = [
					5000, 10000, 20000, 30000, 40000, 50000, 60000, 70000, 80000, 90000,
					100000, 125000, 150000,
				]
			} else if (this.rangeMode === 'power') {
				this.type = 'number'
				this.range.from = {
					title: 'ab',
					key: 'range-from-power',
					model: '',
				}
				this.range.till = {
					title: 'bis',
					key: 'range-till-power',
					model: '',
				}
				this.range.options = [
					25, 37, 44, 55, 66, 74, 87, 96, 110, 147, 185, 223, 263, 296,
				]
			} else if (this.rangeMode === 'firstRegistration') {
				this.type = 'string'
				this.range.from = {
					title: 'ab',
					key: 'range-from-firstRegistration',
					model: '',
				}
				this.range.till = {
					title: 'bis',
					key: 'range-till-firstRegistration',
					model: '',
				}
				this.range.options = [
					202201, 202101, 202001, 201901, 201801, 201701, 201601, 201501,
					201401, 201301, 201201, 201101, 201001, 200901, 200801, 200701,
					200601, 200501,
				]
			}
		},
		updateFilterTill() {
			if (this.range.till.model !== '') {
				const filterItem = {
					adPropertyKey: this.range.till.key,
					adPropertyValue: this.range.till.model,
					adPropertyType: this.type,
				}
				store.commit('updateFilter', filterItem)
			} else {
				store.commit('deleteFilter', this.range.till.key)
			}
			this.$emit('updateFilter', this.model)
		},
		updateFilterFrom() {
			if (this.range.from.model !== '') {
				const filterItem = {
					adPropertyKey: this.range.from.key,
					adPropertyValue: this.range.from.model,
					adPropertyType: this.type,
				}
				store.commit('updateFilter', filterItem)
			} else {
				store.commit('deleteFilter', this.range.from.key)
			}
			this.$emit('updateFilter', this.model)
		},
	},
	created() {
		this.setupRangeMode()
		if (store.state.filterItems[this.range.from.key]) {
			this.range.from.model =
				store.state.filterItems[this.range.from.key].adPropertyValue
		}
		if (store.state.filterItems[this.range.till.key]) {
			this.range.till.model =
				store.state.filterItems[this.range.till.key].adPropertyValue
		}
		this.unsubscribe = store.subscribe((mutation, state) => {
			if (
				mutation.type === 'deleteFilter' ||
				mutation.type === 'deleteAllFilter'
			) {
				if (
					state.filterItems[this.range.from.key] === undefined &&
					this.range.from.model !== ''
				) {
					this.range.from.model = ''
				} else if (
					state.filterItems[this.range.till.key] === undefined &&
					this.range.till.model !== ''
				) {
					this.range.till.model = ''
				}
			}
		})
	},
	beforeUnmount() {
		this.unsubscribe()
	},
}
</script>
